import { createSelector } from '@ngrx/store'
import { EquipmentTemplateState, selectAll } from '../reducers/equipment-template.reducer'

export const selectEquipmentTemplateList = (state): EquipmentTemplateState => state.equipmentState.equipmentTemplate

export const equipmentTemplateList = createSelector(selectEquipmentTemplateList, selectAll)
export const selectedTemplate = createSelector(selectEquipmentTemplateList, templates => templates.selectedTemplate)
